/*
  File name: deadline.js
    Program Description:
    - This file uses the baseUrl method and the specified functions inside the
    rest file in order to send requests from the web application to the server.
    - This file is focused on the requests related to the users feature
*/

import { baseUrl } from '@/settings'
import { get, patch, post, remove, postFormData } from '@/utils/rest'

const users = {
  allUsers: (query) => get(`${baseUrl}/admin/users/${query}`),
  userList: (query, userRole) => get(`${baseUrl}/admin/users/${userRole}${query}`),
  removeUser: (_id, userRole, action, info) => patch(`${baseUrl}/admin/user/${userRole}/${_id}/${action}`, info),
  deleteUser: (_id) => remove(`${baseUrl}/admin/user/profile/${_id}`),
  deactivateUser: (_id, reason) => patch(`${baseUrl}/admin/user/profile/${_id}/deactivate`, reason),
  activateUser: (_id, reason) => patch(`${baseUrl}/admin/user/profile/${_id}/activate`, reason),
  getUser: (userRole, _id) => get(`${baseUrl}/admin/user/profile/${_id}`),
  createUser: (info) => post(`${baseUrl}/admin/users/`, { info }),
  patchUser: (userRole, _id, info) => patch(`${baseUrl}/admin/user/${userRole}/${_id}`, { info }),
  resetPassword: (username) => post(`${baseUrl}/user/password/requestreset`, { username }),
  profile: () => get(`${baseUrl}/user/myprofile`),
  updateProfile: (newInfo) => patch(`${baseUrl}/user/myprofile`, { info: newInfo }),
  uploadID: (_id, type, info) => postFormData(`${baseUrl}/attachment/user/id/${type}/${_id}`, info),
  getID: (_id, type) => get(`${baseUrl}/attachment/user/id/${type}/${_id}`),
  requestAgency: (info) => post(`${baseUrl}/sendEmail/requestAgency`, info),
  referToExpert: (info, _id) => patch(`${baseUrl}/referToExpert/${_id}`, info),
  roles: {
    get: (query) => get(`${baseUrl}/config/roleaccess${query}`),
    view: (userRole) => get(`${baseUrl}/config/roleaccess/${userRole}`),
    create: (info) => post(`${baseUrl}/config/roleaccess`, info),
    update: (roleName, info) => patch(`${baseUrl}/config/roleaccess/${roleName}`, info),
    delete: (roleName) => remove(`${baseUrl}/config/roleaccess/${roleName}`),
    viewSummary: (module) => get(`${baseUrl}/config/roleaccess/summary${module ? `?module=${module}` : ''}`)
  },
  verifyEmail: (query) => get(`${baseUrl}/user/account/verify/email${query}`),
  generateBackupCodes: (username) => post(`${baseUrl}/user/password/generatebackupcodes`, { username }),
  verifyDpoEmail: (username) => post(`${baseUrl}/registration/validate`, { email: username })
}

export default users
